// extracted by mini-css-extract-plugin
export default {"arrowDown":"animationArrow_arrowDown__0W6Co","arrowUp":"animationArrow_arrowUp__+q+CS","down":"animationArrow_down__zj0Lv","up":"animationArrow_up__RAU5y"};